import script from "./IvrPayments.vue?vue&type=script&setup=true&lang=ts"
export * from "./IvrPayments.vue?vue&type=script&setup=true&lang=ts"

import "./IvrPayments.vue?vue&type=style&index=0&id=7dc93df8&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dc93df8"]])

export default __exports__